import { render, staticRenderFns } from "./zrdata - 副本.vue?vue&type=template&id=f3279600&scoped=true"
import script from "./zrdata - 副本.vue?vue&type=script&lang=js"
export * from "./zrdata - 副本.vue?vue&type=script&lang=js"
import style0 from "./zrdata - 副本.vue?vue&type=style&index=0&id=f3279600&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3279600",
  null
  
)

export default component.exports